export var CheggTlds = {
  DEFAULT: '.com',
  MX: '.com.mx'
};
export var LANG_PREFERENCE_COOKIE = 'langPreference';
export var esLocales = ['es-MX', 'es-419', 'es'];